import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import DominioSubtipoForm from './components/formDominioSubtipo';
import {
  headersSubtiposDominio,
  valoresExibidosSubtiposDominio,
} from './utils/auxliarSubtipo';
import BoxConteudo from '../../../../../../components/BoxConteudo';
import CustomButton from '../../../../../../components/CustomButton';
import CustomCol from '../../../../../../components/CustomCol';
import CustomRow from '../../../../../../components/CustomRow';
import Tabela from '../../../../../../components/Tabela';
import { getUser } from '../../../../../../modules/contexts/Auth/RequireAuth';
import { ICorRegistro } from '../../../../../../modules/types/Cor';
import { getAllCores } from '../../../../../../services/cores/corService';
import { getDominiosByPaiId } from '../../../../../../services/dominio/dominioService';
import theme from '../../../../../../theme';
import { useExcelExport } from '../../../../../../utils/excel-export';
import { formatDateToFile } from '../../../../../../utils/functions';
import { optionStatusBin } from '../../utils/optionStatusBin';

interface DominioSubtipoProps {
  idDominioTipo: number;
  recarregarDadosPai: () => void;
}

export default function DominioSubtipo({
  idDominioTipo,
  recarregarDadosPai,
}: DominioSubtipoProps) {
  const user = getUser();
  const userID = user.sub;
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [novoDominioSubtipo, setNovoDominioSubtipo] = useState(false);
  const handleClickInserirNovoDominioSubtipo = () => {
    setSelectedId(null);
    setNovoDominioSubtipo(true);
    setShowOffcanvas(true);
  };

  //////FETCH DATA
  const [data, setData] = useState<any[]>([]);
  const fetchData = async () => {
    try {
      const lista = await getDominiosByPaiId(idDominioTipo);
      setData(Array.isArray(lista) ? lista : []);
    } catch (error) {
      console.error('Erro ao obter dados:', error);
      setData([]);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  //////TABLE E OFFCANVAS
  const tableData =
    data?.map((item) => {
      return {
        id: item.id,
        status: (
          <span
            style={{
              backgroundColor:
                item.status === 1
                  ? theme.colors.verdegov
                  : theme.colors.vermelho,
              borderRadius: '10px',
              padding: '12px',
              display: 'inline-block',
              minWidth: '70px',
              textAlign: 'center',
              color: 'white',
            }}
          >
            {optionStatusBin[item.status]?.label}
          </span>
        ),
        ordem: (
          <span
            style={{
              padding: '12px',
              display: 'inline-block',
              minWidth: '50px',
              textAlign: 'center',
              fontWeight: 'bold',
              fontSize: '14px',
            }}
          >
            {item.ordem}º
          </span>
        ),
        nome: (
          <span
            style={{
              backgroundColor: item.cor.codigoHexadecimal
                ? item.cor.codigoHexadecimal
                : '#FFFFFF',
              color: item.corText === 2 ? 'white' : 'black',
              borderRadius: '10px',
              padding: '12px',
              display: 'inline-block',
              minWidth: '100px',
              textAlign: 'center',
            }}
          >
            {item.nome}
          </span>
        ),
        descricao: item.descricao ? item.descricao : '—',
        subtipos: item.subtipos || '-',
      };
    }) || [];

  const [selectedId, setSelectedId] = useState<number | null>(null);
  const handleRowClick = (id: number) => {
    setSelectedId(id); // registra qual registro deve ser carregado no formulário
    setNovoDominioSubtipo(false); // modo edição
    setShowOffcanvas(true); // abre o offcanvas
  };

  const [allCores, setAllCores] = useState<ICorRegistro[]>([]);
  const [optionsCores, setOptionsCores] = useState<
    { value: number; label: string }[]
  >([]);

  useEffect(() => {
    async function loadCores() {
      const cores = await getAllCores();
      setAllCores(cores);

      const opts = [
        { value: 0, label: 'Não informado' }, // 🔹 Adicionado aqui
        ...cores
          .sort((a, b) => a.nomeCor.localeCompare(b.nomeCor))
          .map((cor) => ({
            value: cor.id,
            label: cor.nomeCor,
          })),
      ];

      setOptionsCores(opts);
    }

    loadCores();
  }, []);

  return (
    <>
      <BoxConteudo boxTitulo="Subtipos do Domínio">
        <CustomRow>
          <CustomCol width="100%">
            <Tabela
              headers={headersSubtiposDominio}
              dataTable={tableData}
              displayValues={valoresExibidosSubtiposDominio}
              onRowClick={handleRowClick}
              dataOffCanvas={[]}
              botaoAbrirOffCanvas={false}
              showPagination={false}
            />
          </CustomCol>
        </CustomRow>
        <CustomCol className="d-flex justify-content-end gap-3">
          <CustomButton
            label="Novo Subtipo de Domínio"
            bgColor={theme.colors.botaoAcao.azul}
            textColor={theme.colors.white}
            onClick={() => {
              handleClickInserirNovoDominioSubtipo();
            }}
          />
        </CustomCol>

        {/* Modal /*/}
        <DominioSubtipoForm
          idDominioTipo={idDominioTipo}
          show={showOffcanvas}
          onHide={() => setShowOffcanvas(false)}
          novoDominioSubtipo={novoDominioSubtipo}
          selectedId={selectedId}
          allCores={allCores}
          optionsCores={optionsCores}
          recarregarDados={fetchData}
          listaOrdemsExistentes={data.map((d) => d.ordem)}
          recarregarDadosPai={recarregarDadosPai}
        />
      </BoxConteudo>
    </>
  );
}
